/**
 * CMSPreferenceInputDirective class defines a directive for handling CMS preference inputs.
 * This class leverages AngularJS services and directives to manage and render preference inputs.
 */
class CMSPreferenceInputDirective {
    /**
     * Constructs a new instance of the CMSPreferenceInputDirective.
     * @param {Object} $compile - AngularJS compile service.
     * @param {Object} $bridges - Custom service for bridge functionalities.
     * @param {Object} TaskDataService - Service for handling task data.
     */
    constructor($compile, $bridges, TaskDataService) {
        this._logIdentifier = 'CMSPreferenceInputDirective';
        this.$compile = $compile;
        this.$bridges = $bridges;
        this.TaskDataService = TaskDataService;
    }

    /**
     * Defines the directive configuration object.
     * @returns {Object} The directive configuration.
     */
    directive() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                theKey: '=key',
                prefData: '=data',
                parentScope: '=scope'
            },
            template: '<div ng-include="getContentUrl()"></div>',
            controller: ['$injector', '$scope', '$rootScope', '$signals', '$interval', 
                function($injector, $scope, $rootScope, $signals, $interval) {
                    $scope.randomId = angular.createUUID();
                    $scope.action = $scope.prefData[$scope.theKey]['action'];
                    $scope.actionText = $scope.prefData[$scope.theKey]['actionText'];
                    $scope.actionAvailable = typeof($scope.action) == 'function';
                    $scope.placeholder = $scope.prefData[$scope.theKey]['placeholder'];
                }
            ],
            link: function($scope, $element, $attribute) {
                $scope.data = $scope.prefData[$scope.theKey];

                const baseUrl = "/views/ib/contentobjects/helpers/",
                      templatePrefix = "cms-preference-",
                      templateSuffix = ".html",
                      supportedTypes = ['text','search','tel','url','email','number','range','checkbox'],
                      cmsSupportedTypes = ['text', 'number', 'hidden'];

                $scope.getContentUrl = function() {
                    let url;
                    if (typeof $scope.data.subtype == 'undefined') {
                        url = baseUrl + templatePrefix + $scope.data.type + templateSuffix;
                    } else if (cmsSupportedTypes.indexOf($scope.data.subtype) == -1) {
                        console.info('Input subtype %s is not yet supported!', $scope.data.subtype);
                    } else {
                        url = baseUrl + templatePrefix + $scope.data.type + '-' + $scope.data.subtype + templateSuffix;
                    }
                    return url;
                };
            }
        };
    }
}

/**
 * Registers the CMS Preference Input directive.
 * @param {Object} module - The AngularJS module to register the directive with.
 */
export default function registerCmsPreferenceInputDirective(module) {
    module.directive('cmsPreferenceInput', ['$compile', '$bridges', 'TaskDataService', 
        function($compile, $bridges, TaskDataService) {
            const directive = new CMSPreferenceInputDirective($compile, $bridges, TaskDataService);
            return directive.directive();
        }
    ]);
}